import { render, staticRenderFns } from "./NumberOfManagement.vue?vue&type=template&id=63ddb45b&scoped=true&"
import script from "./NumberOfManagement.vue?vue&type=script&lang=js&"
export * from "./NumberOfManagement.vue?vue&type=script&lang=js&"
import style0 from "./NumberOfManagement.vue?vue&type=style&index=0&id=63ddb45b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ddb45b",
  null
  
)

export default component.exports